import { SVGProps } from 'react';

export const IconOffers = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox='2 2 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.1101 5.5C11.1436 5.5 10.3601 6.2835 10.3601 7.25C10.3601 7.66421 10.0243 8 9.61011 8C9.19589 8 8.86011 7.66421 8.86011 7.25C8.86011 5.45507 10.3152 4 12.1101 4C13.905 4 15.3601 5.45507 15.3601 7.25C15.3601 7.66421 15.0243 8 14.6101 8C14.1959 8 13.8601 7.66421 13.8601 7.25C13.8601 6.2835 13.0766 5.5 12.1101 5.5Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.86275 7C5.8383 7 4.97949 7.7741 4.87348 8.79305L4.16679 15.5861C3.92126 17.9462 5.77246 20 8.14532 20H15.8548C18.197 20 20.0381 17.9966 19.8406 15.6627L19.2626 8.83137C19.1749 7.79587 18.3089 7 17.2697 7H6.86275ZM10.4576 10.5C10.4576 10.0858 10.1218 9.75 9.7076 9.75C9.29339 9.75 8.9576 10.0858 8.9576 10.5C8.9576 12.2949 10.4127 13.75 12.2076 13.75C14.0025 13.75 15.4576 12.2949 15.4576 10.5C15.4576 10.0858 15.1218 9.75 14.7076 9.75C14.2934 9.75 13.9576 10.0858 13.9576 10.5C13.9576 11.4665 13.1741 12.25 12.2076 12.25C11.2411 12.25 10.4576 11.4665 10.4576 10.5Z'
        fill='currentColor'
      />
    </svg>
  );
};
